<div class="container dialog-container">

  <div class="row">
    <h2 i18n>Set {{data.title}}</h2>
  </div>

  <div class="form-field-container">

    <mat-form-field appearance="fill" style="flex-grow: 1;">
      <mat-label i18n>Degrees</mat-label>
      <input matInput #deg type="text" inputmode="decimal" [size]="latLonLen" [maxlength]="latLonLen"  (input)="_handleInput(degrees, latLonLen, min)" [formControl]="degrees">
    </mat-form-field>

    <mat-form-field appearance="fill" style="flex-grow: 1; margin-left: 5px;">
      <mat-label i18n>Minutes</mat-label>
      <input matInput #min type="text" inputmode="decimal" size="2" maxlength="2" (input)="_handleInput(minutes, 2, minDec)" [formControl]="minutes">
    </mat-form-field>



    <span style="font-size:xx-large;">.</span>

    <mat-form-field appearance="fill" style="flex-grow: 1;">
      <input matInput #minDec type="text" inputmode="decimal" size="2" maxlength="2" [formControl]="decimalMinutes" (input)="_forbidNonNumeric(decimalMinutes)" (keyup.enter)="onConfirm()">
      @if (latLonLen == 2) {
        <span matSuffix style="font-weight:bold">N</span>
        }@if (latLonLen == 3) {
        <span matSuffix style="font-weight:bold">W</span>
      }
    </mat-form-field>


  </div>

  <div class="row" style="justify-content: space-between;">
    <div class="col-5">
      <button i18n mat-raised-button class="cancel-button" (click)="dialogRef.close()">
                  Cancel
            </button>

    </div>
    <div class="col-5">
      <button i18n mat-raised-button class="coral-button" type="submit" (click)="onConfirm()">
                Confirm
            </button>         
    </div>
  </div>

</div>
